import React from "react";

function EventChat() {
  return <>Chat</>;
}

export default EventChat;
